import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./App";
import "./index.css";

// vite-react-ssg entry. Replaces createRoot(...).render(<App/>).
// During `vite-react-ssg build`, this is invoked in Node to render each route
// to a static HTML file. In the browser it hydrates the same routes.
export const createRoot = ViteReactSSG(
  {
    routes,
    basename: "/",
  },
);
